import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

function lazyLoad(viewPath) {
  return () => import(`@views/${viewPath}`);
}

const routes = [
  { path: '/', name: 'Home', component: lazyLoad('Home.vue') },
  // TEST URLS
  { path: '/test/:tid', name: 'GiveTest', component: lazyLoad('tests/GiveTest.vue') },
  { path: '/test/edit/:tid', name: 'EditTest', component: lazyLoad('tests/EditTest.vue') },
  { path: '/test/:tid/cheating', name: 'TestCheating', component: lazyLoad('tests/TestCheating.vue') },
  { path: '/test/:tid/stats', name: "TestStats", component: lazyLoad('tests/TestStats.vue') },
  { path: '/test/:tid/stats/student/:sid', name: "StudentResult", component: lazyLoad('tests/StudentResult.vue') },

  // AUTH URLS
  { path: '/login', name: 'Login', component: lazyLoad('auth/Login.vue') },
  { path: '/logout', name: 'Logout', component: lazyLoad('auth/Logout.vue') },
  { path: '/restricted', name: 'Restricted', component: lazyLoad('auth/Restricted.vue') },
  { path: '/notfound', name: 'NotFound', component: lazyLoad('tests/NotFound.vue') },

  { path: "*", component: lazyLoad('default/PageNotFound.vue') },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = JSON.parse(localStorage.getItem('currentUser'));

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login' + "?next=" + to.path);
  } else {
    next();
  }
});


export default router
